module.exports = __webpack_public_path__ + "home-block-5-overlay-wide@2x-8mFuiGg.png";